import ConfirmationBlock from './ConfirmationBlock';
import { ConfirmationBlockProps, ConfirmationBlockValueProps } from './types';

export type { ConfirmationBlockProps, ConfirmationBlockValueProps };
export default ConfirmationBlock;
